import { render, staticRenderFns } from "./ModalCommonContent.vue?vue&type=template&id=9b6345b6&scoped=true"
import script from "./ModalCommonContent.vue?vue&type=script&lang=js"
export * from "./ModalCommonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6345b6",
  null
  
)

export default component.exports